// third-party
import { FormattedMessage } from 'react-intl';

// assets
import ArticleIcon from '@mui/icons-material/Article';
import ExtensionIcon from '@mui/icons-material/Extension';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import QuizIcon from '@mui/icons-material/Quiz';
import SchoolIcon from '@mui/icons-material/School';

// type
import ERoutes from 'routes/ERoutes';
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS - CONTENT MANAGEMENT ||============================== //

const contentManagement: NavItemType = {
    id: 'Content Management',
    title: <FormattedMessage id="Content Management" />,
    icon: ArticleIcon,
    type: 'group',
    // Gate the whole Content Management group so Developer never sees the menu;
    // the sidebar only hides a top-level group when the group itself carries `roles`.
    roles: ['superAdmin', 'customerService'],
    url: ERoutes.pageList,
    children: [
        {
            id: 'page-management',
            title: 'Pages',
            type: 'item',
            icon: NewspaperIcon,
            url: ERoutes.pageList,
            breadcrumbs: false
        },
        {
            id: 'onboarding-questionnaire',
            title: 'Onboarding Questionnaires',
            type: 'item',
            icon: QuizIcon,
            url: ERoutes.onboardingQuestionnaire,
            breadcrumbs: false
        },
        {
            id: 'onboarding-templates',
            title: 'Onboarding Templates',
            type: 'item',
            icon: FactCheckIcon,
            url: ERoutes.onboardingTemplates,
            breadcrumbs: false
        },
        {
            id: 'training-manual',
            title: 'Training manual',
            type: 'item',
            icon: SchoolIcon,
            url: ERoutes.trainingManualTemplate,
            breadcrumbs: false
        },
        {
            id: 'crm-contract-templates',
            title: 'Contract templates',
            type: 'item',
            icon: HistoryEduIcon,
            url: ERoutes.crmContractTemplates,
            breadcrumbs: false
        },
        {
            id: 'integration-cards',
            title: 'Integrations',
            type: 'item',
            icon: ExtensionIcon,
            url: ERoutes.integrationCardList,
            breadcrumbs: false,
            // Global, all-business advertise-only cards — authoring is Super Admin only,
            // so the child item carries its own `roles` gate even though the group is broader.
            roles: ['superAdmin']
        }
    ]
};

export default contentManagement;
